module.exports = __webpack_public_path__ + "img/percolate.d1d0b39a.svg";